let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fA3RA")).then(() => parcelRequire('2PZ1K'));